import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  requirement: [],
  allRequirement: [],
  addRequirementData: [],
};

export const RequirementSlice = createSlice({
  name: "requirement",
  initialState,
  reducers: {
    getRequirementAction: (state, action) => {
      
      state.requirement = action.payload;
    },
    getAllRequirementAction: (state, action) => {
      
      state.allRequirement = action.payload;
    },
    getAddRequirementDataAction: (state, action) => {
      
      state.addRequirementData = action.payload;
    },
  },
});

export default RequirementSlice.reducer;

export const { getRequirementAction, getAllRequirementAction, getAddRequirementDataAction } = RequirementSlice.actions;
